import * as React from 'react';
import { getIconCSSForAttachment } from '../utils/getIconCSSForAttachment';
import { getCloudIconCSSForAttachment } from '../utils/getCloudIconCSSForAttachment';

const styles = require('./CloudIconWithOverlay.scss');
const iconStyles = require('./AttachmentIconView.scss');
const classNames = require('classnames');

export interface CloudIconWithOverlayProps {
    fileName: string;
    contentType: string;
    isBlocked: boolean;
    isFolder: boolean;
    embeddedItemClass: string;
    cloudyIconStyle?: any;
    fileIconStyle?: any;
}

export class CloudIconWithOverlay extends React.Component<CloudIconWithOverlayProps, any> {
    render() {
        const {
            fileName,
            cloudyIconStyle,
            contentType,
            fileIconStyle,
            isBlocked,
            isFolder,
            embeddedItemClass,
        } = this.props;

        const cloudIconCSS: string = getCloudIconCSSForAttachment(
            fileName,
            contentType,
            isBlocked,
            isFolder,
            embeddedItemClass
        );
        const fileIconCSS: string = getIconCSSForAttachment(
            fileName,
            contentType,
            isBlocked,
            isFolder,
            embeddedItemClass
        ).small;

        return (
            <div
                className={classNames(
                    iconStyles.icon,
                    cloudIconCSS,
                    cloudyIconStyle ? cloudyIconStyle : iconStyles.iconDefault
                )}>
                <div
                    className={classNames(
                        fileIconCSS,
                        fileIconStyle ? fileIconStyle : styles.fileIcon
                    )}
                />
            </div>
        );
    }
}
